export default "__VITE_ASSET__BXFTCWCd__"